import {
  CartApi,
  CheckoutV2Api,
  ContactApi,
  CorporatePassApi,
  CourseClassesApi,
  PreferenceApi,
  ProductsApi,
  PromotionApi,
  SearchApi,
  SuggestionApi
} from '@api';
import { DefaultHttpService, HttpService } from './common/services/HttpService';
import { LegacySyncStorage } from './services/LegacySyncStorage';
import { MergeService } from './services/MergeService';

class ServiceInjector {
  readonly http: HttpService = new DefaultHttpService();

  readonly cartApi = new CartApi(this.http);

  readonly contactApi = new ContactApi(this.http);

  readonly courseClassesApi = new CourseClassesApi(this.http);

  readonly productsApi = new ProductsApi(this.http);

  readonly promotionApi = new PromotionApi(this.http);

  readonly checkoutApi = new CheckoutV2Api(this.http);

  readonly searchApi = new SearchApi(this.http);

  readonly preferenceApi = new PreferenceApi(this.http);

  readonly corporatePassApi = new CorporatePassApi(this.http);

  readonly mergeService = new MergeService();

  readonly legacySyncStorage = new LegacySyncStorage();

  readonly suggestionsApi = new SuggestionApi(this.http);
}

export const Injector = new ServiceInjector();